<script>
import inViewport from 'vue-in-viewport-mixin'

const config = {
  MAX_STEP: 4,
  // In ms
  INIT_DELAY: 500,
  // In ms
  INTERVAL: 1000,
  // In ms
  RESTART_DELAY: 4000
}

export default {
  name: 'HomeCoreModules',
  mixins: [ inViewport ],

  data () {
    return {
      step: -1,
      ended: false,

      initTimer: null,
      showNextTimer: null,
      restartTimer: null
    }
  },

  watch: {
    'inViewport.now' (isTrue) {
      if (isTrue) {
        this.start()
      }
    }
  },

  methods: {
    start () {
      clearTimeout(this.initTimer)
      if (this.step < 0) {
        this.initTimer = setTimeout(() => {
          clearTimeout(this.initTimer)
          this.nextStep()
        }, config.INIT_DELAY)
      }
    },

    nextStep () {
      if (this.ended) {
        clearTimeout(this.showNextTimer)
        return
      }
      this.step++

      if (this.step >= config.MAX_STEP) {
        this.ended = true
        clearTimeout(this.restartTimer)
        this.restartTimer = setTimeout(() => {
          clearTimeout(this.restartTimer)
          this.restart()
        }, config.RESTART_DELAY)
      } else {
        this.resetTimer()
      }
    },

    restart () {
      // Restart again
      this.step = -1
      this.ended = false
      this.start()
    },

    resetTimer () {
      clearTimeout(this.showNextTimer)
      this.showNextTimer = setTimeout(() => {
        clearTimeout(this.showNextTimer)
        this.nextStep()
      }, config.INTERVAL)
    }
  },

  mounted () {
    clearTimeout(this.initTimer)
    clearTimeout(this.showNextTimer)
    clearTimeout(this.restartTimer)
    if (this.inViewport && this.inViewport.now) {
      this.start()
    }
  },

  beforeDestroy () {
    clearTimeout(this.initTimer)
    clearTimeout(this.showNextTimer)
    clearTimeout(this.restartTimer)
  }
}
</script>

<template lang="pug">
section.edu-core-modules-graph
  .graph-inner

    transition(name="fade" appear)
      .module-block.module-block-1(v-if="step >= 0")
        .block-title 测评计划
        .block-subtitle 心理评估与发展指导工具库
        .block-text 心理健康&emsp;学情诊断&emsp;生涯规划&emsp;……

    transition(name="fade" appear)
      .module-block.module-block-2(v-if="step >= 1")
        .block-title 心理档案

    transition(name="fade" appear)
      .module-block.module-block-3(v-if="step >= 2")
        .block-title 危机档案

    transition(name="fade" appear)
      .module-block.module-block-4(v-if="step >= 3")
        .block-title 评估与干预

    transition(name="fade" appear)
      .module-block.module-block-5(v-if="step >= 4")
        .block-title 咨询管理
        .block-text 预约日历&emsp;预约记录&emsp;咨询记录

    transition(name="fade" appear)
      .module-block.module-block-6(v-if="step >= 2")
        .block-title 团体分析

    .arrows-container(v-if="step >= 0")
      transition(name="fadeDown" appear)
        .arrow.arrow-1.dmico-anime-arrow-down(v-if="step >= 0")
      transition(name="fadeDown" appear)
        .arrow.arrow-2.dmico-anime-arrow-down-long(v-if="step >= 1")
      transition(name="fadeLeft" appear)
        .arrow.arrow-3.dmico-anime-arrow-right(v-if="step >= 2")
      transition(name="fadeUp" appear)
        .arrow.arrow-4.dmico-anime-arrow-up(v-if="step >= 3")
      transition(name="fadeUp" appear)
        .arrow.arrow-5.dmico-anime-arrow-up(v-if="step >= 4")
      transition(name="fadeUp" appear)
        .arrow.arrow-6.dmico-anime-arrow-up-medium(v-if="step >= 4")
      transition(name="fadeLeft" appear)
        .arrow.arrow-7.dmico-anime-arrow-right(v-if="step >= 1")
      transition(name="fadeUp" appear)
        .arrow.arrow-8.dmico-anime-arrow-up(v-if="step >= 2")

</template>

<style lang="scss">
@import "../../styles/variables";

section.edu-core-modules-graph {
  position: relative;
  width: 455px;
  height: 550px;
  color: $text-dark;

  .graph-inner {
    @include absFullSpread;
  }

  .block-title {
    color: $primary-color;
    font-size: 22px;
    font-weight: 600;
  }

  .block-subtitle {
    color: #fff;
    margin-top: 10px;
    background: $primary-color;
    border-radius: 6px;
    padding: 6px 20px;
    font-size: 16px;
  }

  .block-text {
    margin-top: 15px;
    font-size: 16px;
  }

  .module-block {
    position: absolute;
    z-index: 1;
    box-shadow: 0 0 36px black(0.1);
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    &.module-block-1 {
      width: 455px;
      height: 150px;
      top: 0;
      left: 0;
    }

    &.module-block-2 {
      width: 170px;
      height: 90px;
      top: 180px;
      left: 5px;
    }

    &.module-block-3 {
      width: 170px;
      height: 90px;
      bottom: 0;
      left: 5px;
    }

    &.module-block-4 {
      width: 240px;
      height: 90px;
      bottom: 0;
      right: 5px;
    }

    &.module-block-5 {
      width: 365px;
      height: 160px;
      bottom: 105px;
      right: 5px;
    }

    &.module-block-6 {
      width: 170px;
      height: 90px;
      top: 180px;
      left: 205px;
    }
  }

  .arrows-container {
    @include absFullSpread;
    z-index: 50;

    .arrow {
      position: absolute;
      animation-delay: .5s;
    }

    .arrow-1 {
      top: 140px;
      left: 80px;
    }

    .arrow-2 {
      left: 20px;
      bottom: 80px;
    }

    .arrow-3 {
      bottom: 26px;
      left: 165px;
    }

    .arrow-4 {
      bottom: 80px;
      right: 80px;
    }

    .arrow-5 {
      left: 105px;
      top: 255px;
    }

    .arrow-6 {
      right: 30px;
      top: 135px;
    }

    .arrow-7 {
      top: 205px;
      left: 165px;
    }

    .arrow-8 {
      top: 140px;
      right: 150px;
    }
  }
}
</style>
